import React, { useEffect, useState } from "react";
import "./Header.css";
import Slide1 from "../../../../assets/images/header-slide1.png";
const Header = () => {
  const slides = [
    {
      id: 1,
      imageUrl: Slide1,
      overlayColor: "transparent",
      textContent: (
        <div className="header__text_headingwrap">
          <div className="header__text_headingtitle">WE PROVIDE</div>
          <div className="header__text_heading">
            Highly Professional Services
          </div>
        </div>
      ),
    },
  ];

  const [activeSlide, setActiveSlide] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prevSlide) =>
        prevSlide === slides.length ? 1 : prevSlide + 1
      );
    }, 5000); // Change the interval time as needed (e.g., 5000ms for 5 seconds)

    return () => clearInterval(interval); // Clear the interval on component unmount
  }, [slides.length]);

  return (
    <div className="header__wrap">
      {slides.map((slide) => (
        <div
          key={slide.id}
          className={`header__slide ${
            slide.id === activeSlide ? "header__slide_active" : ""
          }`}
          style={{
            backgroundImage: `url(${slide.imageUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            className="header__slide_overlay"
            style={{ backgroundColor: slide.overlayColor }}
          >
            <div className="header__slide_text">{slide.textContent}</div>
          </div>
        </div>
      ))}

      <div className="header__slide_dots">
        {slides.map((slide) => (
          <span
            key={slide.id}
            className={`header__slide_dot ${
              slide.id === activeSlide ? "header__slide_activedot" : ""
            }`}
            onClick={() => setActiveSlide(slide.id)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Header;
